import type { IntlShape } from "react-intl";

// A failed save's HTTP status as the thing the admin can fix: not signed in, not an admin, feature not
// configured, or the config store failing. Shared by the cards that save to gemstone through /ai/*.
export function modelConfigSaveErrorMessage(intl: IntlShape, status: number): string {
  switch (status) {
    case 401:
      return intl.formatMessage({
        id: "model.saveError.unauthorized",
        defaultMessage: "Your session has expired – sign in again.",
      });
    case 403:
      return intl.formatMessage({
        id: "model.saveError.forbidden",
        defaultMessage: "You need admin rights to change the model configuration.",
      });
    case 501:
      return intl.formatMessage({
        id: "model.saveError.notConfigured",
        defaultMessage: "Model configuration isn't enabled on this server.",
      });
    case 502:
      return intl.formatMessage({
        id: "model.saveError.upstream",
        defaultMessage: "Couldn't reach the configuration store – try again.",
      });
    default:
      return intl.formatMessage({
        id: "model.saveError",
        defaultMessage: "Couldn't save model settings – try again.",
      });
  }
}
